const ToggleNav = (hmBtn, header, body, nav) => {
  if (hmBtn.checked) {
    OpenNav(header, body, nav)

    return
  }

  CloseNav(header, null, body, nav)
}
const OpenNav = (header, body, nav) => {
  header.classList.add('--open')
  body.classList.add('--open')
  nav.classList.add('--open')
}
const CloseNav = (header, hmBtn = null, body, nav) => {
  header.classList.remove('--open')
  body.classList.remove('--open')
  nav.classList.remove('--open')

  if (hmBtn) {
    hmBtn.checked = false
    hmBtn.dispatchEvent(new Event('change'))
  }
}
const followMe = (header) => {
  if (window.pageYOffset >= 1) {
    header.classList.add('--followme')

    return
  }

  header.classList.remove('--followme')
}

const Nav = () => {
  const header = document.querySelector('header')

  if(!header) return

  const nav    = document.querySelector('header nav')
  const hmBtn  = header.querySelector('.hamburger-menu input')
  const body   = document.querySelector('.body')

  hmBtn.addEventListener('change', (e) => {
    e.stopPropagation()
    ToggleNav(e.currentTarget, header, body, nav)
  })

  window.addEventListener('resize', (e) => {
    if (e.currentTarget.innerWidth >= 1024) {
      hmBtn.checked = false
      hmBtn.dispatchEvent(new Event('change'))
    }
  })

  window.addEventListener('load', () => {
    setTimeout(() => {
      CloseNav(header, hmBtn, body, nav)
    }, 50)
  })

  followMe(header)

  window.addEventListener('scroll', () => {
    followMe(header)
  })
}
export default Nav
